// src/components/layouts/MapLayout.js
import React from "react";
import TopAppBar from "../navigation/TopAppBar";
import BottomNav from "../navigation/BottomNav";
import { TOP_APP_BAR_HEIGHT } from "../../constants/constants";
import { BOTTOM_NAV_BAR_HEIGHT } from "../../constants/constants";
import { Box, Container } from "@mui/material";
// import { getAuth } from "firebase/auth";


const MapLayout = ({ children }) => {
    // const auth = getAuth();
    // const user = auth.currentUser;
    const topAppBarOffset = `calc(${TOP_APP_BAR_HEIGHT}px + env(safe-area-inset-top, 0px))`;

    return (
        <Box
            display="flex"
            flexDirection="column"
            minHeight="100vh"
            sx={{ backgroundColor: "background.default", color: "text.primary" }}
        >
            <TopAppBar />
            {/* Spacer to offset the fixed TopAppBar */}
            <Box sx={{ height: topAppBarOffset }} />

            <Container
                component="main"
                sx={{
                    flexGrow: 1,
                    height: "100%",         // <-- Make the container fill its parent’s height
                    overflow: "hidden",     // <-- Disable page‐level scrolling in this layout
                    // full–width on mobile, then narrower on md/lg
                    width: { xs: "100%", md: "75%", lg: "60%" },
                    // center horizontally on md+ breakpoints
                    mx: { xs: 0, md: "auto" },
                    // preserve mobile padding
                    px: { xs: 0, sm: 0 },
                    py: { xs: 0, sm: 0 },
                }}
            >
                {children}
            </Container>

            {/* Spacer to offset the fixed BottomNav */}
            <Box sx={{ height: `${BOTTOM_NAV_BAR_HEIGHT}px` }} />
            <BottomNav />
        </Box>
    );
};

export default MapLayout;
